import { Box, Button, InputAdornment, Stack, TextField } from "@mui/material"
import PageHeader from "../../components/PageHeader/PageHeader"
import Filters from "./AccountsFilters"
import {
  getBankList,
  getBankNames,
  getPaymentModes,
  selectBankAccounts,
  resetFilters,
  setFiltersFromURL,
  setFilters,
  setBankAccountFilterCount,
  bankAccountsInitialState,
} from "../../slices/bankAccountsSlice"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { useEffect, useState } from "react"
import { BankTable } from "./BankTable"
import queryString from "query-string"
import { useLocation, useNavigate } from "react-router-dom"
import { PageHeaderAction } from "./AccountsPageHeaderAction"
import {
  ContentWrapper,
  StyledButton,
  StyledCircle,
  StyledFilterDrawer,
} from "../Transactions/styles"
import { HeaderGrid } from "../../components/HeaderGrid"
import { Search, FilterAltRounded } from "@mui/icons-material"
import CloseIcon from "@mui/icons-material/Close"
import { BankAccountsContainer, GridParent } from "./styles"

export const BankAccounts = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const [filterOpen, setFilterOpen] = useState(false)
  const drawerWidth = 280
  const { bankList, isbankListLoading, filters, isDeactivated, filterCount } =
    useAppSelector(selectBankAccounts)
  useEffect(() => {
    dispatch(getPaymentModes())
    dispatch(getBankNames())

    // URL Parameters to Redux State
    const params = queryString.parse(location.search)
    if (Object.keys(params).length !== 0) {
      const updatedFilters = { ...filters, ...params }
      dispatch(setFiltersFromURL(updatedFilters))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchBankList = () => {
    dispatch(setBankAccountFilterCount())
    const params = queryString.stringify(filters)
    navigate({ search: params })
    dispatch(getBankList(filters))
  }

  useEffect(() => {
    if (
      JSON.stringify(filters) ===
      JSON.stringify(bankAccountsInitialState.filters)
    )
      fetchBankList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters])

  //  refetch list after successfull deactivation with applied filters
  useEffect(() => {
    if (isDeactivated) dispatch(getBankList(filters))
  }, [isDeactivated, dispatch, filters])

  useEffect(() => {
    fetchBankList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.search])

  // reset filter handler
  const ResetFilterHandler = () => {
    setFilterOpen(false)
    dispatch(resetFilters())
  }

  //handle refresh
  const handleRefresh = () => {
    dispatch(getBankList(filters))
  }

  const handleDrawerClose = () => {
    setFilterOpen(false)
  }

  const ApplyFilterHandler = () => {
    fetchBankList()
    setFilterOpen(false)
  }

  return (
    <GridParent>
      <PageHeader
        title="Bank Accounts"
        actions={<PageHeaderAction handleRefresh={handleRefresh} />}
      />
      <BankAccountsContainer>
        <ContentWrapper isOpen={filterOpen} drawerWidth={drawerWidth}>
          <Stack spacing={2} sx={{ height: "100%" }}>
            <HeaderGrid
              leftChildren={[
                <TextField
                  size="small"
                  variant="outlined"
                  label="Search"
                  placeholder="Search by Account Name, Number & Zoho Id"
                  value={filters.search}
                  onChange={(e) => {
                    dispatch(setFilters({ ...filters, search: e.target.value }))
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                  }}
                />,
                <StyledButton
                  variant="outlined"
                  startIcon={<FilterAltRounded fontSize="small" />}
                  endIcon={
                    Boolean(filterCount) && (
                      <StyledCircle>{filterCount}</StyledCircle>
                    )
                  }
                  color="inherit"
                  onClick={() => setFilterOpen(!filterOpen)}
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: "100px",
                  }}
                >
                  Filters
                </StyledButton>,
              ].filter((child) => Boolean(child))}
            />

            <BankTable bankList={bankList} isLoading={isbankListLoading} />
          </Stack>
        </ContentWrapper>
        <StyledFilterDrawer
          variant={filterOpen ? "persistent" : "temporary"}
          anchor="right"
          open={filterOpen}
          sx={{
            flexShrink: 0,
          }}
        >
          <Box sx={{ flexGrow: 1, p: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mb: 2,
              }}
            >
              <Button color="inherit" onClick={handleDrawerClose}>
                <CloseIcon />
              </Button>
            </Box>
            <Filters
              ApplyFilterHandler={ApplyFilterHandler}
              ResetFilterHandler={ResetFilterHandler}
            />
          </Box>
        </StyledFilterDrawer>
      </BankAccountsContainer>
    </GridParent>
  )
}
